<script setup lang="ts">
import UiFieldContainer from './UiFieldContainer.vue'
import UiIcon from './UiIcon.vue'
import UiText from './UiText.vue'

export interface UiLinkFieldProps {
  label?: string
  value?: string | null
  copyLabel?: string
  class?: string | string[] | Record<string, boolean>
}

const props = withDefaults(defineProps<UiLinkFieldProps>(), {
  copyLabel: 'Copy',
  value: '',
  class: '',
})

const emit = defineEmits<{
  (e: 'copy', value: string): void
  (e: 'copySuccess', value: string): void
}>()

async function copyValue() {
  if (!props.value) return
  if (!navigator.clipboard) return
  await navigator.clipboard.writeText(props.value)
  emit('copy', props.value)
  emit('copySuccess', props.value)
}
</script>

<template>
  <div class="flex w-full flex-col gap-1" :class="props.class">
    <UiText v-if="props.label" as="label" variant="p-small" class="font-semibold text-se-dark" :text="props.label" />
    <UiFieldContainer gap="0" class="overflow-hidden pr-0">
      <a
        v-if="props.value"
        :href="props.value"
        target="_blank"
        rel="noopener noreferrer"
        class="min-w-0 flex-1 truncate text-md text-se-dark se-font-input font-archivo"
      >
        {{ props.value }}
      </a>
      <span v-else class="min-w-0 flex-1 truncate text-md text-se-gray-500 se-font-input font-archivo">
        Not available
      </span>
      <button
        type="button"
        class="-my-px flex cursor-pointer self-stretch items-center gap-2 border-l border-se-gray-300 px-4 text-se-dark transition-colors hover:bg-se-gray-100 disabled:cursor-not-allowed disabled:text-se-gray-400 disabled:hover:bg-transparent"
        :disabled="!props.value"
        @click.stop="copyValue"
      >
        <UiIcon name="copy" class="h-5 w-5" />
        <UiText as="span" variant="p-small" class="font-semibold" :text="props.copyLabel" />
      </button>
    </UiFieldContainer>
  </div>
</template>
